import AcmeProto from "generated/proto/Acme";
import { CashierPersonalOfferResponse as Offer } from "generated/proto/CashierPersonalOffer";
import { ChatEventsAcmePayload } from "generated/proto/ChatEvents";
import {
  ReadMessageEvent,
  SelfReadMessageEvent,
} from "generated/proto/ReadMessageEvents";
import { TransactionStatusMessage } from "generated/proto/TransactionProtos";
import { AcmeServiceName } from "src/enums";
import {
  ACME_CHAT_EVENT_SENT_IDENTIFICATOR,
  ACME_READ_MESSAGE_EVENT_IDENTIFICATOR,
  ACME_SELF_READ_MESSAGE_EVENT_IDENTIFICATOR,
} from "src/features/chat/constants";
import { parseMessageFromBase64 } from "src/utils/protobufUtil";
import { textEncoder } from "utils/textEncoder";

const { OverrideableMessage, RefreshMessage } = AcmeProto;

export const parseAcme = (decodedAcme, onAcme) => {
  onAcme({
    data: {
      acmeId: decodedAcme.id,
    },
  });

  if (decodedAcme.serviceName === AcmeServiceName.FINANCE) {
    const { serviceName, serviceIdentifier, payload } = parseMessageFromBase64(
      decodedAcme.payload,
      OverrideableMessage
    );

    const data = parseMessageFromBase64(payload, TransactionStatusMessage);
    onAcme({
      serviceName,
      serviceIdentifier,
      data,
    });

    return;
  }

  if (decodedAcme.serviceName === AcmeServiceName.FACILITATOR) {
    const refreshMessage = RefreshMessage.decode(
      textEncoder.encode(decodedAcme.payload)
    );

    refreshMessage && onAcme(refreshMessage);
  }

  if (decodedAcme.serviceName === AcmeServiceName.PERSONAL_OFFERS) {
    const { serviceName, serviceIdentifier, payload } = parseMessageFromBase64(
      decodedAcme.payload,
      OverrideableMessage
    );

    const data = parseMessageFromBase64(payload, Offer);
    onAcme({
      serviceName,
      serviceIdentifier,
      data: {
        ...data,
        ts: Date.now(),
      },
    });
  }

  if (decodedAcme.id.indexOf(ACME_READ_MESSAGE_EVENT_IDENTIFICATOR) !== -1) {
    const { serviceName, serviceIdentifier, payload } = parseMessageFromBase64(
      decodedAcme.payload,
      OverrideableMessage
    );

    const data = parseMessageFromBase64(payload, ReadMessageEvent);
    onAcme({
      serviceName,
      serviceIdentifier,
      data: {
        ...data,
        ts: Date.now(),
        isViewed: false,
      },
    });
  }

  if (
    decodedAcme.id.indexOf(ACME_SELF_READ_MESSAGE_EVENT_IDENTIFICATOR) !== -1
  ) {
    const { serviceName, serviceIdentifier, payload } = parseMessageFromBase64(
      decodedAcme.payload,
      OverrideableMessage
    );

    const data = parseMessageFromBase64(payload, SelfReadMessageEvent);
    onAcme({
      serviceName,
      serviceIdentifier,
      data: {
        ...data,
        ts: Date.now(),
        isViewed: false,
      },
    });
  }

  if (decodedAcme.id.indexOf(ACME_CHAT_EVENT_SENT_IDENTIFICATOR) !== -1) {
    const { serviceName, serviceIdentifier, payload } = parseMessageFromBase64(
      decodedAcme.payload,
      OverrideableMessage
    );

    const preparedPayload = parseMessageFromBase64(
      payload,
      ChatEventsAcmePayload
    );

    onAcme({
      serviceName,
      serviceIdentifier,
      data: {
        ...preparedPayload,
        ts: Date.now(),
        isViewed: false,
      },
    });
  }
};
